<template>
    <v-app-bar
        app
        clipped-left
        class="dsp-header"
        color="white"
        extension-height="48px"
        :height="headerHeight"
        flat>
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <div class="d-flex flex-column">
                <div class="d-flex">
                    <dsp-logo class="mr-2"></dsp-logo>
                    <year-toggle></year-toggle>
                </div>
                <div class="d-flex">
                    <p class="ma-0 py-3 dsp-cycle__short-description">
                        DSPolitical technology powered over 2,000 campaigns and causes in 2024. Explore below to learn more.
                    </p>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <v-btn @touchstart="onTouchstart"
                               v-click-outside="{
                                  handler: onClickOutside,
                                  closeConditional: onCloseConditional
                                }"
                               icon>
                            <v-icon>info</v-icon>
                        </v-btn>
                        <v-alert v-if="hover || show" class="dsp-cycle__tooltip">
                            <p class="ma-0 pt-2 dsp-cycle__site-description">
                                Discover how DSPolitical's cutting-edge technology shaped the 2024 election. From advanced targeting strategies to impactful CTV campaigns, our tools helped clients, candidates, and partners drive voter engagement and make a difference up and down the ballot.
                            </p>
                        </v-alert>
                      </div>
                    </v-hover>
                </div>
            </div>
            </v-col>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <call-to-action v-if="$vuetify.breakpoint.mdAndUp"></call-to-action>
        </v-row>
        <template 
            v-if="$vuetify.breakpoint.smAndDown"
            v-slot:extension>
            <v-row dense>
                <v-col>
                    <geography-selector></geography-selector>
                </v-col>
                <v-col>
                    <narrative-selector></narrative-selector>
                </v-col>
            </v-row>
        </template>
    </v-app-bar>
</template>

<script>
    import dspLogo from "../dspLogo";
    import mailchimpEmbed from "./mailchimpEmbed";
    import GeographySelector from '../navigation/GeographySelector';
    import NarrativeSelector from '../navigation/NarrativeSelector';
    import YearToggle from "./YearToggle";
    import CallToAction from "./CallToAction";
   
    export default {
        name: "dspHeader",
        components: {
            CallToAction,
            dspLogo,
            mailchimpEmbed,
            GeographySelector,
            NarrativeSelector,
            YearToggle
        },
        data () {
            return {
                show: false,
            }
        },
        computed: {
            headerHeight() {
                if (this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly) {
                    return "130px";
                } else {
                    return "140px";
                }
            }
        },
        methods: {
            // onClickOutside and onCloseConditional are being used for dismissing the tooltip on mobile
            onClickOutside() {
                this.show = false;
            },
            onCloseConditional() {
                return this.show;
            },
            onTouchstart() {
                this.show = !this.show;
            }
        }
    }
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";

    .dsp-cycle__short-description {
        display: flex;
        flex-direction: column;
        flex-basis: 256px;
        flex-grow: 0;
    }

    .dsp-cycle__short-description,
    .dsp-cycle__site-description {
        font-size: 12px;
        line-height: 12px;
    }

    .dsp-cycle__tooltip {
        z-index: 1;
        position: absolute;
        transform: translate(48px, -48px);
        width: 460px;
        padding-top: 8px;
        border-color: black !important;
        border-style: solid;
        border-width: 1px;
        background-color: white;

        @media screen and (max-width: $sm) {
            width: 300px;
        }

        @media screen and (max-width: 800px) {
            transform: translate(0, 0);
            right: 20px;
        }
    }

    .dsp-header{
        &__cta-container{
            max-width: 500px;
        }
        &__cta {
            .v-card__title{
                font-size: 14px;
                line-height: 16px;
                color: $secondary;
                font-weight: bold;
                word-break: normal;
            }
            .v-card__text{
                min-height: 50px;
            }
        }
    }

    .v-toolbar__extension {
        z-index: -1; // Tooltip is shown under the geography+narrative selectors in small screens without this
        padding-bottom: 30px;
    }
</style>